import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { initEmbedMarketoForm } from '../../services/marketoService';
import Button from 'components/Button';
import { MarketoEmbeddedContent } from './styles';

const MarketoEmbedded = ({
  className,
  dataPosition,
  formType,
  marketoFormId,
  modalMode,
  closeModal,
  title,
  onSuccess,
  shouldRedirect,
  theme,
}) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [isFormSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    initEmbedMarketoForm(
      marketoFormId,
      setFormSubmitted,
      onSuccess,
      shouldRedirect,
      dataPosition,
      formType
    );
  }, []);

  const formContent = (
    <MarketoEmbeddedContent
      className={'marketo-embedded-form ' + className}
      modalMode={modalMode}
      theme={theme}
    >
      <div
        className={'marketo-embedded--container ' + (isFormSubmitted ? ' thanks-container' : '')}
      >
        {!isFormSubmitted ? (
          <>
            {title && <h2 className="marketo-embedded--form-title">{title}</h2>}
            <form data-formId={marketoFormId} className="mktoForm"></form>
          </>
        ) : (
          <>
            <h2>
              You've already submitted form.
              <br />
              <br />
              Thanks for submitting.
            </h2>
            <Button onClick={closeModal}>Ok</Button>
          </>
        )}
      </div>
    </MarketoEmbeddedContent>
  );

  return modalMode ? (
    <Modal
      visible={modalOpen}
      closable={true}
      footer={null}
      maskClosable={true}
      onCancel={() => setModalOpen(false)}
      bodyStyle={{ padding: 0 }}
    >
      {formContent}
    </Modal>
  ) : (
    formContent
  );
};

export default MarketoEmbedded;
